export default __webpack_public_path__ + "static/media/3435 spice rack E top.66433b44.png";